"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingPage = void 0;
const paper_1 = require("client/components/material/paper");
const react_1 = require("react");
const React = require("react");
class FloatingPage extends react_1.Component {
    render() {
        return React.createElement(paper_1.MaterialPaper, { noPadding: true }, this.props.children);
    }
}
exports.FloatingPage = FloatingPage;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/page/floating-page/floating-page.tsx
// module id = 2787
// module chunks = 0 1